<template>
    <div class="loader">
        <div class="loader__element" :style="bottomMobileMenuIsShow ? 'top:0':false"></div>
    </div>
</template>

<script>

import {mapState} from "vuex";

export default {
    name: 'TheLoader',
    computed:{
      ...mapState({
        bottomMobileMenuIsShow: state => state.bottomMobileMenuIsShow,
      }),
    },
    data() {
        return {
            isShow: true,
        }
    }
};
</script>

<style scoped>

.loader {
    z-index: 101 !important;
}

.loader__element {
    z-index: 999999;
    border-radius: 12px;
    overflow: hidden;
    height: 5px;
    width: 100%;
    background: rgba(154, 43, 11, 0.55);
    position: fixed;
    top: 0;
    transition: top 0.3s ease-in-out;
}
@media (max-width: 992px) {
  .loader__element {
    height: 3px;
    top: 55px;
  }
}
.loader__element:before {
    content: '';
    display: block;
    background-color: #9A2B0B;
    height: 4px;
    width: 0;
    animation: getWidth 2s ease-in infinite;
}

@keyframes getWidth {
    100% {
        width: 100%;
    }
}
</style>
